"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromListAttrDTO = void 0;
const index_js_1 = require("../../../../attributes/list/index.js");
const attribute_js_1 = require("./attribute.js");
/**
 * @debt feature "handle defaults, links & validators"
 */
const fromListAttrDTO = ({ defaults, links, elements, ...props }) => {
    defaults;
    links;
    return (0, index_js_1.list)((0, attribute_js_1.fromAttrDTO)(elements), props);
};
exports.fromListAttrDTO = fromListAttrDTO;
